@if (editMode) {
  <div>
  </div>
}
@if (!editMode) {
  <div>
    <div class="separator"></div>
  </div>
}
